export const widgetIndex = [
    {
        label: 'Sales Summary',
        indexKey: 'daily'
    },
    {
        label: 'Site Status',
        indexKey: 'siteStatus'
    },
    {
        label: 'Totals',
        indexKey: 'totals',
        minHeight: '50svh'
    },
    {
        label: 'Counts',
        indexKey: 'counts',
        minHeight: '50svh'
    },
    {
        label: 'Income By Hour',
        indexKey: 'incomeByHour',
        minHeight: '40svh'
    },
    {
        label: 'Sales',
        indexKey: 'sales',
        minHeight: '40svh'
    },
    {
        label: 'App Activity',
        indexKey: 'appActivity'
    },
    {
        label: 'ExpressPass Activity',
        indexKey: 'expressPassActivity'
    },
    {
        label: 'Loyalty Point Awards',
        indexKey: 'appLoyaltyPointAwards'
    },
    {
        label: 'Top Wash Club Users',
        indexKey: 'appTopWashClubUsers'
    },
    {
        label: 'Top ExpressPass Users',
        indexKey: 'topExpressPassUsers'
    },
    {
        label: 'Birthday Washes',
        indexKey: 'appBirthdayWashes'
    },
    {
        label: 'Total Washes',
        indexKey: 'washCount'
    }
]

export const defaultWidgets = widgetIndex.map(e => e.indexKey);
